import type { ReactNode } from "react";

/**
 * The label above a page headline. Sentence case at 14px/600 in the teal-tinted
 * label tone — never a tracked uppercase eyebrow, which is the tell of the
 * template this design refuses.
 */
export function PageLabel({ children }: Readonly<{ children: ReactNode }>) {
  return <p className="page-label">{children}</p>;
}

interface PageIntroProps {
  children: ReactNode;
  /** The design runs the lede one step down on pain-points and up on about. */
  size?: "lg" | "sm";
}

/** The lede under a page headline. */
export function PageIntro({ children, size }: Readonly<PageIntroProps>) {
  const className = size ? `page-intro is-${size}` : "page-intro";
  return <p className={className}>{children}</p>;
}
